// Load userData from localStorage on initialization
const loadUserDataFromStorage = () => {
  try {
    const storedUserData = localStorage.getItem('userData');
    if (storedUserData) {
      return JSON.parse(storedUserData);
    }
  } catch (error) {
    console.error('Error loading userData from localStorage:', error);
  }
  return null;
};

// Load currentUser from localStorage on initialization
const loadCurrentUserFromStorage = () => {
  try {
    const storedUser = localStorage.getItem('currentUser');
    if (storedUser) {
      return JSON.parse(storedUser);
    }
  } catch (error) {
    console.error('Error loading currentUser from localStorage:', error);
  }
  return null;
};

// Load email from localStorage
const loadEmailFromStorage = () => {
  try {
    return localStorage.getItem('resetEmail') || null;
  } catch (error) {
    console.error('Error loading email from localStorage:', error);
    return null;
  }
};

// Load code from localStorage
const loadCodeFromStorage = () => {
  try {
    return localStorage.getItem('resetCode') || null;
  } catch (error) {
    console.error('Error loading code from localStorage:', error);
    return null;
  }
};

// Load settings from localStorage
const loadSettingsFromStorage = () => {
  try {
    const storedSettings = localStorage.getItem('settings');
    if (storedSettings) {
      return JSON.parse(storedSettings);
    }
  } catch (error) {
    console.error('Error loading settings from localStorage:', error);
  }
  return null;
};

export const state = {
  currentUser: loadCurrentUserFromStorage(),
  userData: loadUserDataFromStorage(),
  resetEmail: loadEmailFromStorage(),
  resetCode: loadCodeFromStorage(),
  settings: loadSettingsFromStorage()
};

export const getters = {
  loggedIn: (state) => !!state.currentUser,
  currentUser: (state) => state.currentUser,
  userData: (state) => state.userData,
  getEmail: (state) => state.resetEmail,
  getCode: (state) => state.resetCode,
  getSetting: (state) => state.settings
};

export const mutations = {
  SET_USER(state, user) {
    state.currentUser = user;
    // Persist to localStorage only if user has data
    if (user && (user.id || user._id || user.email || user.name)) {
      localStorage.setItem('currentUser', JSON.stringify(user));
    }
    // Don't remove from localStorage here - only on explicit logout
  },
  SET_USER_DATA(state, userData) {
    state.userData = userData;
    // Persist to localStorage - always save if userData exists
    if (userData && (userData.id || userData._id || userData.email || userData.name)) {
      localStorage.setItem('userData', JSON.stringify(userData));
    }
    // Don't remove from localStorage here - only on explicit logout
  },
  CLEAR_USER(state) {
    state.currentUser = null;
    state.userData = null;
    state.resetEmail = null;
    state.resetCode = null;
    // Remove from localStorage only on explicit logout
    localStorage.removeItem('currentUser');
    localStorage.removeItem('userData');
    localStorage.removeItem('resetEmail');
    localStorage.removeItem('resetCode');
  },
  SET_EMAIL(state, email) {
    state.resetEmail = email;
    if (email) {
      localStorage.setItem('resetEmail', email);
    } else {
      localStorage.removeItem('resetEmail');
    }
  },
  SET_CODE(state, code) {
    state.resetCode = code;
    if (code) {
      localStorage.setItem('resetCode', code);
    } else {
      localStorage.removeItem('resetCode');
    }
  },
  SET_SETTINGS(state, settings) {
    state.settings = settings;
    if (settings) {
      localStorage.setItem('settings', JSON.stringify(settings));
    } else {
      localStorage.removeItem('settings');
    }
  }
};

export const actions = {
  setUser({ commit }, user) {
    commit('SET_USER', user);
  },
  setUserData({ commit }, userData) {
    commit('SET_USER_DATA', userData);
  },
  clearUser({ commit }) {
    commit('CLEAR_USER');
  },
  setEmail({ commit }, email) {
    commit('SET_EMAIL', email);
  },
  setCode({ commit }, code) {
    commit('SET_CODE', code);
  },
  setSettings({ commit }, settings) {
    commit('SET_SETTINGS', settings);
  }
};

